import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import CoverageTemplate, {
  CoverageType,
} from "../../components/coverage-template"

import {
  CoverageContractorsGeneralLiabilityMidMarketMeta,
  CoverageContractorsGeneralLiabilitySmallBusinessMeta,
  CoverageContractorsMeta,
  CoverageEnvironmentalOverviewMeta,
  CoverageExcessCasualtyMeta,
  CoverageOwnersInterestMeta,
} from "../../data/seo-meta"

import {
  ContractorsGLMidMarketBrochure,
  ContractorsGLSmallBusinessBrochure,
  EnvironmentalBrochure,
  ExcessCasualtyBrochure,
} from "../../data/brochures"

import contractorsIcon from "../../images/coverage/industry/contracting.svg"

const related = [
  {
    name: "Contractors GL - Small Business",
    href: CoverageContractorsGeneralLiabilitySmallBusinessMeta.path,
  },
  {
    name: "Contractors GL - Mid-Market",
    href: CoverageContractorsGeneralLiabilityMidMarketMeta.path,
  },
  { name: "Environmental", href: CoverageEnvironmentalOverviewMeta.path },
  { name: "Excess Casualty", href: CoverageExcessCasualtyMeta.path },
  { name: "Owner’s Interest", href: CoverageOwnersInterestMeta.path },
  // TODO: coming at a later date
  // { name: "Hired and Non-Owned Auto", href: "" },
  // { name: "Project Specific", href: "" },
  // { name: "Trucker’s Supplemental", href: "" },
]

const downloads = [
  {
    name: "Brochure - Contractors GL - Small Business",
    href: ContractorsGLSmallBusinessBrochure,
  },
  {
    name: "Brochure - Contractors GL - Mid-Market",
    href: ContractorsGLMidMarketBrochure,
  },
  { name: "Brochure - Environmental", href: EnvironmentalBrochure },
  { name: "Brochure - Excess Casualty", href: ExcessCasualtyBrochure },
]

const CoverageContractorsPage = () => (
  <Layout>
    <SEO
      description={CoverageContractorsMeta.description}
      path={CoverageContractorsMeta.path}
      title={CoverageContractorsMeta.title}
    />
    <CoverageTemplate
      icon={contractorsIcon}
      type={CoverageType.Industry}
      title={CoverageContractorsMeta.title}
      description={CoverageContractorsMeta.description}
      related={related}
      downloads={downloads}
    >
      <h3 className="h3">TARGET CLASSES</h3>
      <ul>
        <li>Artisan Trade contractors</li>
        <li>Commercial* general contractors</li>
        <li>Contractors with gross receipts up to $25 million</li>
        <li>Owner’s Interest Policies</li>
        <li>Project Specific CGL Policies</li>
        <li>
          Residential contractors performing repair or remodel work (no HOA
          work)
        </li>
      </ul>

      <h3 className="h3">UNACCEPTABLE CLASSES</h3>
      <ul>
        <li>Accounts in bankruptcy</li>
        <li>All New York state contractors</li>
        <li>Any contractor performing residential work in Colorado</li>
        <li>
          New residential contractors performing work in New Tracts,
          Condominiums or Town homes
        </li>
        <li>Roofing Contractors</li>
        <li>Wrap-ups</li>
      </ul>

      <h3 className="h3">COVERAGES/CAPACITY</h3>
      <h4 className="h4 -mb-4">
        Contractors General Liability – $1M each occurrence
      </h4>
      <ul>
        <li>Additional insured for job owners</li>
        <li>Contractors environmental coverage sublimit up to $100,000</li>
        <li>Employee Benefits coverage available</li>
        <li>Primary and Noncontributory</li>
        <li>Waiver of Transfer of Rights</li>
      </ul>

      <h4 className="h4 -mb-4 mt-8">Inland Marine</h4>
      <ul>
        <li>
          Coverage available for Scheduled Contractors Equipment and / or Small
          Tools (unscheduled)
        </li>
        <li>
          Coverage available for rented / leased equipment, as well as employee
          tools and clothing
        </li>
        <li>
          Maximum of $1,000,000 per schedule, and up to $150,000 for any one
          piece of equipment
        </li>
      </ul>

      <h4 className="h4 -mb-4 mt-8">Project Specific Policies</h4>
      <ul>
        <li>Per Project Aggregate</li>
      </ul>

      <h4 className="h4 mt-8">Owner’s Interest Policies</h4>

      <h4 className="h4 -mb-4">Also available under separate cover:</h4>
      <ul>
        <li>Environmental</li>
        <li>Excess Liability</li>
      </ul>

      <h3 className="h3">FINANCIAL SECURITY</h3>
      <ul>
        <li>AM Best rated A++</li>
        <li>Standard & Poor’s assigned A+</li>
      </ul>

      <h3 className="h3">SERVICES</h3>
      <p className="p2">
        Risk Management Services
        <br />
        *Apartment construction is considered commercial work (No HOA work)
      </p>
    </CoverageTemplate>
  </Layout>
)

export default CoverageContractorsPage
